import type { FlappyDuelView } from '@minigame-race/contracts';
import type { MinigameProps } from '../../race/types.js';
import { FlappyBoard } from '../../turn/FlappyBoard.js';
import { TurnBoardFrame } from '../../turn/TurnBoardFrame.js';

/** Flappy duel as a race segment. See ConnectFourGame for the turn-adapter note. */
export function FlappyGame({ view, emit }: MinigameProps) {
  const v = view as FlappyDuelView | null;
  if (!v || v.kind !== 'flappy') return null;
  return (
    <TurnBoardFrame>
      <FlappyBoard view={v} onMove={emit} />
    </TurnBoardFrame>
  );
}
